import React from "react";
import styled from "styled-components";

const StyledYoutubeViewer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  iframe {
    padding: 0.6rem;
  }
`;

const YoutubeViewer = ({ videoUrl, width = 1280, height = 720 }) => {
  return (
    <>
      <StyledYoutubeViewer>
        <iframe
          title="youtube-video"
          width={width}
          height={height}
          src={`https://www.youtube.com/embed/${videoUrl}`}
          frameBorder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </StyledYoutubeViewer>
    </>
  );
};

export default YoutubeViewer;
